export class RequestObjectModel<T> {
  public body: T;

  constructor(data: T) {
    this.body = data;
  }
}
